import type { FieldProblem, ProblemParams } from '@volee/api-client'

import { EN_FIELD_ERRORS, EN_GENERIC_FIELD_ERROR } from './en/field-errors.ts'
import { IT_FIELD_ERRORS, IT_GENERIC_FIELD_ERROR } from './it/field-errors.ts'
import { locale } from './locale.ts'

// Validation keys of a 422, active language. Partial by construction (Pydantic's vocabulary
// is open): uncovered keys fall back to the response's English `message`, on the record.
/** The catalogue of the active language. */
export const FIELD_ERRORS: Readonly<Record<string, string>> =
  locale === 'en' ? EN_FIELD_ERRORS : IT_FIELD_ERRORS

/** Shown when the key is not covered and the response carries no `message`. */
export const GENERIC_FIELD_ERROR = locale === 'en' ? EN_GENERIC_FIELD_ERROR : IT_GENERIC_FIELD_ERROR

function interpolateParams(text: string, params: ProblemParams | null): string {
  if (params === null) return text
  return text.replace(/\{(\w+)\}/g, (placeholder, key: string) => {
    const value = params[key]
    return value == null ? placeholder : String(value)
  })
}

/** The message for a field a 422 rejected: the key's translation, else the response's
 *  `message`, else a generic sentence — so no Pydantic key leaves a field unexplained. */
export function translateFieldError(problem: FieldProblem): string {
  const translated = FIELD_ERRORS[problem.code]
  if (translated !== undefined) return interpolateParams(translated, problem.params)
  return problem.message ?? GENERIC_FIELD_ERROR
}
